/** @typedef {{ type?: string; code?: unknown }} StreamAttachment */

/** @typedef {{ text?: string; deleted_at?: unknown; type?: string; attachments?: StreamAttachment[] }} StreamMessageLike */

/**
 * @param {StreamAttachment | undefined} attachment
 */
export function isReservationAttachment(attachment) {
  return attachment?.type === 'reservation'
}

/**
 * @param {StreamMessageLike | undefined | null} message
 * @returns {string | null}
 */
export function getReservationCodeFromMessage(message) {
  const attachments = message?.attachments
  if (!attachments?.length) {
    return null
  }
  for (let i = attachments.length - 1; i >= 0; i -= 1) {
    const attachment = attachments[i]
    if (!isReservationAttachment(attachment)) {
      continue
    }
    const code = attachment?.code
    if (typeof code === 'string' && code.trim()) {
      return code.trim()
    }
  }
  return null
}

/**
 * @param {string} code
 */
export function formatReservationPreviewCode(code) {
  const trimmed = code.trim()
  if (!trimmed) {
    return ''
  }
  return trimmed.startsWith('#') ? trimmed : `#${trimmed}`
}

/**
 * Last visible preview line for a channel list row.
 * Reservation-only messages show `#CODE` (or empty when code is missing).
 *
 * @param {{ state?: { messages?: StreamMessageLike[] } }} channel
 * @param {{ maxLength?: number }} [options]
 * @returns {string}
 */
export function getChannelLastMessagePreview(channel, options = {}) {
  const { maxLength } = options
  const msgs = channel.state?.messages
  if (!msgs?.length) {
    return ''
  }

  for (let i = msgs.length - 1; i >= 0; i -= 1) {
    const message = msgs[i]
    if (!message || message.deleted_at || message.type === 'system') {
      continue
    }

    const text = (message.text || '').trim()
    if (text) {
      if (maxLength && text.length > maxLength) {
        return `${text.slice(0, maxLength)}…`
      }
      return text
    }

    const reservationCode = getReservationCodeFromMessage(message)
    if (reservationCode) {
      return formatReservationPreviewCode(reservationCode)
    }

    if (message.attachments?.length) {
      return ''
    }
  }

  return ''
}
